export const STYLE_TAG_ALL = 'all'

const tagLabelKey = id => `viewerSidebar.enhance.render.stylePanel.tags.${id}`

// The category chips. Each preset's `tags` from /api/internal/generator/style_presets
// carries these ids; the chips are kept here so their order is stable.
export const STYLE_TAGS = [
  STYLE_TAG_ALL,
  'style',
  'character',
  'environment',
  'theme',
  'material',
  'effect',
  'object',
  'enhancer',
  'abstract',
].map(id => ({ id, labelKey: tagLabelKey(id) }))
